(function (jQuery, undefined) {

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.custom === "undefined") {
        jQuery.extend(sm.portal.vm, { custom: {}});
    }
    if (typeof sm.portal.vm.custom.continuing_education === "undefined") {
        jQuery.extend(sm.portal.vm.custom, { continuing_education: {}});
    }

    function LocalizeKeys() {
      var keys = {
        HideTaxID : true,
        HideHispanic : true,
        HideVeteran : true,
        HideCurrentEmployerSearch : true,
        HideAddressFormat : true,
        ResidentState : 'Province',
        TaxIdTemplate : 'ContinuingEducation.TaxId',
        CurrentEmployerTemplate : 'ContinuingEducation.CurrentEmployer',
        AddressFormatTemplate : 'ContinuingEducation.AddressFormat',
        HideCoreFields: true
      }
      return keys;      
    }

    function LoadTemplates() {
        var data = ['ContinuingEducation'];

        return data;
    }

    function UpdateAddressFields(data) {
        var defaultTemplate = false;
        data.availableTemplates().forEach(function (element) {
            if (element.DefaultSiteTemplate() && element.DefaultCountryTemplate() && element.IsObsolete() == false) {
                data.selectedTemplateID(element.ID());
                defaultTemplate = true;
            }
            else if (element.BusinessMeaningName() == "MailAddressTemplate.AllFields" && !element.IsObsolete() && !defaultTemplate) {
                data.selectedTemplateID(element.ID());
                defaultTemplate = true;
            }
            else if (element.BusinessMeaningName() == "MailAddressTemplate.Simple" && !element.IsObsolete() && !defaultTemplate) {
                data.selectedTemplateID(element.ID());
            }
        });
    }

    function UpdateEmploymentDataItem(data) {
        data.dataItem.CurrentEmployerFlexi = ko.observable(data.settings.CurrentEmployerFlexi);
    }

    function UpdateEmploymentInfo(data) {
        data.stdEmploymentInformation.FlexiFieldValues = {
            CurrentEmployer: [{
                CurrentEmployer: data.currentEmployerFlexi()
            }]
        }
    }

    function RedirectToCustomPage() {
        var params = 'title=' + btoa('CA-Online Enrolment');

        jQuery.ajax({
            url: window.AdaptorAjaxURI,
            type: 'GET',
            data: {
                action: 'get_page_url',
                params: params
            },
            success: function (data, textStatus, jqXHR) {
                window.location=data;
            },
            error: function (jqXHR, exception) {
                window.location = '/index.php';
            }
        });
    }

    jQuery.extend(true, sm.portal.vm.custom.continuing_education, {
        LocalizeKeys: LocalizeKeys,
        LoadTemplates: LoadTemplates,
        UpdateAddressFields: UpdateAddressFields,
        UpdateEmploymentDataItem: UpdateEmploymentDataItem,
        UpdateEmploymentInfo: UpdateEmploymentInfo,
        RedirectToCustomPage: RedirectToCustomPage
    });

})(jQuery);